
import Vue from 'vue';
import type { PropOptions } from 'vue';
import type { IPostPoll } from '@/types/community';
import RadioButtonGroup from '@/components/common/RadioButtonGroup/RadioButtonGroup.vue';
import WarRoomPostPollResults from '@/components/partials/war-room/WarRoomPostPoll/WarRoomPostPollResults.vue';
import { sortByField } from '~/components/utils/sorting_func';
import { scrollToHTMLElement } from '~/components/utils/browser/ui';

export default Vue.extend({
  name: 'WarRoomPostPoll',
  components: {
    RadioButtonGroup,
    WarRoomPostPollResults,
  },
  props: {
    poll: {
      type: Object,
      required: true,
    } as PropOptions<IPostPoll>,
    isAuthor: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data(): { timeoutId: number } {
    return {
      timeoutId: -1,
    };
  },
  computed: {
    radioGroupChoices(): Array<{ label: string; value: string; position: number }> {
      return this.poll.choices
        .map(({ id, text, position }) => ({
          label: text,
          value: id.toString(),
          position,
        }))
        .sort(sortByField('position'));
    },
    voteable(): boolean {
      if (this.isAuthor) return false;

      return !this.poll.choices.some(({ current_vote: currentVote }) => !!currentVote);
    },
    showHint(): boolean {
      return this.voteable && this.poll.expired_for_commission;
    },
  },
  mounted(): void {
    const pollRef = this.$refs.poll;
    if (this.$route.query.poll === 'true' && pollRef instanceof HTMLElement) {
      this.timeoutId = window.setTimeout(() => {
        scrollToHTMLElement(pollRef);
      }, 500);
    }
  },
  destroyed() {
    clearTimeout(this.timeoutId);
  },
  methods: {
    onVote(choice: number) {
      this.$emit('vote', Number(choice));
    },
  },
});
